import { CommonModule } from "@angular/common";
import { Component, ElementRef, OnInit } from "@angular/core";
import { CookieService } from "@src/app/servicios/cookies/cookie.service";
import { ConfigService } from "src/app/servicios/config/config.service";
import { Cookie } from "@src/app/models/interfaces/cookie";

enum cookieType {
  "Sin especificar",
  "Necesaria",
  "Rendimiento",
  "Funcional",
  "Publicidad",
}

@Component({
  selector: "app-politica-cookies",
  templateUrl: "./politica-cookies.component.html",
  styleUrls: ["./politica-cookies.component.css"],
  imports: [CommonModule],
  providers: [CookieService],
})
export class PoliticaCookiesComponent implements OnInit {
  public cookies: any[] = [];
  public nombreSociedad;
  public nombreEmpresa;

  constructor(
    private readonly configService: ConfigService,
    private readonly elementRef: ElementRef,
    private readonly cookieService: CookieService,
  ) {}

  ngOnInit(): void {
    this.getConfig();
    this.getCookies();
  }

  /**
   * La función "getCookies" recupera la configuración de las cookies de un servicio y convierte la
   * duración de cada cookie al formato deseado.
   */
  getConfig(): void {
    this.configService.getConfigPrensa().subscribe((resultConfig) => {
      if (!resultConfig) {
        return;
      }
      const selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
      const configBloque = resultConfig.general[selectorName];
      this.nombreEmpresa = resultConfig.general["app-home"].autor_empresa;
      this.nombreSociedad = configBloque["nombre_sociedad"];
    });
  }

  getCookies(): void {
    this.cookieService
      .loadCookiesPrensa()
      .then((cookies: Cookie[]) => {
        this.cookies = cookies?.map((cookie) => {
          return {
            ...cookie,
            tipo: cookieType[cookie.tipo],
            duracion: this.convertDuration(cookie.duracion),
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /**
   * La función `convertDuration` toma una duración en segundos y la convierte a un formato de cadena
   * legible que incluye años, meses, semanas, días, horas, minutos y segundos.
   * @param {number} duracion - El parámetro "duración" representa la duración en segundos que desea
   * convertir a un formato legible por humanos.
   * @returns La función `convertDuration` devuelve una cadena que representa la duración en un formato
   * legible.
   */
  convertDuration(duracion: number): string {
    if (duracion < 0) {
      return "Sesión";
    }
    if (Number(duracion) === 99999999999) {
      return "Persistente";
    }
    const years = Math.floor(duracion / (365 * 24 * 60 * 60));
    duracion -= 365 * 24 * 60 * 60 * years;

    const months = Math.floor(duracion / (30 * 24 * 60 * 60));
    duracion -= 30 * 24 * 60 * 60 * months;

    const weeks = Math.floor(duracion / (7 * 24 * 60 * 60));
    duracion -= 7 * 24 * 60 * 60 * weeks;

    const days = Math.floor(duracion / (24 * 60 * 60));
    duracion -= 24 * 60 * 60 * days;

    const hours = Math.floor(duracion / (60 * 60));
    duracion -= 60 * 60 * hours;

    const minutes = Math.floor(duracion / 60);
    const seconds = duracion - 60 * minutes;

    const partes: string[] = [];

    if (years > 0) {
      partes.push(`${years} ${years === 1 ? "año" : "años"}`);
    }
    if (months > 0) {
      partes.push(`${months} ${months === 1 ? "mes" : "meses"}`);
    }
    if (weeks > 0) {
      partes.push(`${weeks} ${weeks === 1 ? "semana" : "semanas"}`);
    }
    if (days > 0) {
      partes.push(`${days} ${days === 1 ? "día" : "días"}`);
    }
    if (hours > 0) {
      partes.push(`${hours} ${hours === 1 ? "hora" : "horas"}`);
    }
    if (minutes > 0) {
      partes.push(`${minutes} ${minutes === 1 ? "minuto" : "minutos"}`);
    }
    if (seconds > 0) {
      partes.push(`${seconds} ${seconds === 1 ? "segundo" : "segundos"}`);
    }

    let ultimo = "";
    if (partes.length > 1) {
      ultimo = " y " + partes.pop();
    }
    return partes.join(", ") + ultimo;
  }
}
